import urls from "../../global/constants/UrlConstants";
import { getCallParams, makeCall } from "../../utils/service";

export const compatibilityForUsersProfiles = async (
  profile1: string,
  profile2: string,
  language: string
) => {
  try {
    const callParams = await getCallParams("POST", { profile1, profile2 });
    const response = await makeCall(
      `${urls.compatibilityForUsersProfiles}/${language}`,
      callParams
    );
    return response;
  } catch (error: any) {
    throw error;
  }
};
